import { DateUtils } from './DateUtils';

const MIN_CALENDAR_WEEKS = 4;
const MIN_CALENDAR_HEIGHT = 262;
const EXTRA_ROW_HEIGHT = 48;
const DAYS_IN_A_WEEK = 7;

const getCalendarHeight = (date, firstDayOfWeek = 0) => {
    const firstOfMonth = DateUtils.getFirstDayOfMonth(date);
    const lastOfMonth = DateUtils.getLastDayOfMonth(date);
    const dayOfWeek = firstOfMonth.getDay(); // Sunday == 0

    let squaresToAdd = dayOfWeek - firstDayOfWeek;
    if (squaresToAdd < 0) {
        squaresToAdd = DAYS_IN_A_WEEK;
    }

    const totalOfSquares = lastOfMonth.getDate() + squaresToAdd;
    const totalLines = Math.ceil(totalOfSquares / DAYS_IN_A_WEEK);

    const extra = totalLines - MIN_CALENDAR_WEEKS;
    return MIN_CALENDAR_HEIGHT + extra * EXTRA_ROW_HEIGHT;
};

export const CalendarUtils = {
    getCalendarHeight,
};
